import { UnitOfMeasureEnum } from '@enums/recipe-enums';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { GroupProps } from '@repo/ui/src/types';
import ShoppableIngredient from '@views/RecipeDetailPage/ShoppableIngredient';

interface Props {
  group: GroupProps;
  unitOfMeasure: number;
}

const IngredientList = ({ group, unitOfMeasure }: Props) => {
  return (
    <div key={group.groupKey} className="mt-3">
      <h6 className="tra-text-web-heading-6 text-left mb-0">{group.groupName}</h6>
      <ul className="list-none py-4 pl-0 m-0 grid grid-cols-[auto_1fr] gap-y-4">
        {group.ingredients.map((ingredient, i) => {
          return (
            <li key={`ingredient-${i}`} itemProp="recipeIngredient" className="contents">
              <span className="tra-text-web-body-s mb-0 pr-2 border-r text-nowrap">
                {unitOfMeasure === UnitOfMeasureEnum.Imperial ? (
                  <>
                    {ingredient?.imperial?.measurementDisplay} {ingredient?.unitOfMeasure}
                  </>
                ) : (
                  <>
                    {ingredient?.metric?.measurementDisplay} {ingredient?.metric?.unitOfMeasure}
                  </>
                )}
              </span>
              {ingredient?.ingredient?.product ? (
                <ShoppableIngredient product={ingredient.ingredient.product} />
              ) : (
                <span className="tra-text-web-body-l mb-0 pl-2">
                  {ingredient?.ingredient?.link?.link ? (
                    <Anchor
                      className="text-brand-300 underline hover:underline"
                      link={ingredient.ingredient.link.link}
                    >
                      {ingredient?.ingredient?.name}
                    </Anchor>
                  ) : (
                    ingredient?.ingredient?.name
                  )}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default IngredientList;
